package app.nestbridge.feature.children.ui

import app.nestbridge.feature.children.screen.CreateChildProfileScreen
import app.nestbridge.feature.children.screen.CreateChildProfileState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class CreateChildProfileUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is CreateChildProfileScreen -> ui<CreateChildProfileState> { state, modifier -> CreateChildProfileUi(state = state, modifier = modifier) }
    else -> null
  }
}
